export default "__VITE_ASSET__C5urUhr5__"